import { render, staticRenderFns } from "./FailedPayments.vue?vue&type=template&id=28f6e4c3"
import script from "./FailedPayments.vue?vue&type=script&lang=js"
export * from "./FailedPayments.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports